module.exports = __webpack_public_path__ + "static/7-35b5c93046e661b65c410c62f5744046.png";